export const EXPERIMENTS = {
	// example
	dummy123_dummy_experiment: import.meta.env
		.VUE_APP_EXPERIMENT_dummy123_dummy_experiment,
	// add more here...
};

export type ExperimentName = keyof typeof EXPERIMENTS;
